import { Grid, Theme, Typography } from "@mui/material";
import React, { FunctionComponent } from "react";
import { makeStyles } from "tss-react/mui";
import ReportIcon from "@mui/icons-material/Report";

interface WarningConfirmDialogProps {
    headline: string;
    textContent: string;
}

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        padding: 24,
        paddingBottom: 0,
    },

    headline: {
        fontSize: "1.3rem",
        marginBottom: 10,
    },

    icon: {
        fontSize: "64px !important",
        color: "rgba(255,200,0)",
    },
}));

const WarningConfirmDialog: FunctionComponent<WarningConfirmDialogProps> = ({
    headline,
    textContent,
}): JSX.Element => {
    const { classes } = useStyles();

    return (
        <Grid container className={classes.container} spacing={1}>
            <Grid item xs={4}>
                <ReportIcon className={classes.icon} />
            </Grid>
            <Grid xs={8}>
                <Typography className={classes.headline}>{headline}</Typography>
                <Typography gutterBottom>{textContent}</Typography>
            </Grid>
        </Grid>
    );
};

export default WarningConfirmDialog;
